import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

import academicPdf from "../assets/university-act.pdf";
import nonAcademicPdf from "../assets/AmendmentLetter.pdf";

const departments = [
    { name: "विश्वविद्यालय अधिनियम", pdf: academicPdf },
    { name: "संशोधित अधिनियम", pdf: nonAcademicPdf }
];

export default function UniversityAct() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [selectedDeptIndex, setSelectedDeptIndex] = useState(0);

    useEffect(() => {
        function handleResize() {
            setShowSidebar(window.innerWidth >= 768);
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const currentHeaderTitle = departments[selectedDeptIndex] ? departments[selectedDeptIndex].name : "अधिनियम जानकारी";

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn text-white fw-bold d-md-none m-2 rounded"
                style={{ backgroundColor: "#77236b", borderColor: "#77236b" }}
                onClick={() => setShowSidebar(!showSidebar)}
                aria-controls="university-sidebar"
                aria-expanded={showSidebar}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside
                className={`text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3 bg-white`}
                id="university-sidebar"
            >
                <h5 className="text-center fw-bold mb-3">विश्वविद्यालय अधिनियम</h5>
                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept, index) => (
                        <p
                            key={index}
                            className={`mb-2 p-2 rounded small shadow-sm ${selectedDeptIndex === index
                                ? "text-white fw-bold border border-light"
                                : "bg-light text-dark"
                                }`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: selectedDeptIndex === index ? "#77236b" : undefined
                            }}
                            onClick={() => setSelectedDeptIndex(index)}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 d-flex flex-column align-items-center">
                {/* Header for PDF Box */}
                <div className="w-100 text-center py-2 mb-4 rounded" style={{ backgroundColor: "#77236b", color: "white" }}>
                    <h4 className="mb-0 fw-semibold">{currentHeaderTitle}</h4>
                </div>
                {selectedDeptIndex === null ? (
                    <h5 className="text-center mt-5">कृपया अधिनियम चुनें</h5>
                ) : (
                    <div
                        className="border rounded p-5 shadow-sm text-center" // Changed p-4 to p-5 for more padding
                        style={{ maxWidth: "600px", width: "100%" }}
                    >
                        <div className="d-flex justify-content-center gap-3">
                            <a
                                href={departments[selectedDeptIndex].pdf}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn text-white fw-semibold"
                                style={{ backgroundColor: "#77236b", borderColor: "#77236b" }}
                            >
                                📄 PDF खोलें
                            </a>
                            <a
                                href={departments[selectedDeptIndex].pdf}
                                download
                                className="btn btn-success"
                            >
                                ⬇️ PDF डाउनलोड करें
                            </a>
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
}